<div class="card">
  <div class="card-body">
    <div class="d-flex">
      <div>
        <h3 class="card-title m-b-5">
          <span class="lstick"></span>Units Overview
        </h3>
      </div>
      <!-- <div class="ml-auto">
        <select class="custom-select b-0">
          <option selected="">January 2017</option>
          <option value="1">February 2017</option>
          <option value="2">March 2017</option>
          <option value="3">April 2017</option>
        </select>
      </div> -->
    </div>
    <div style="height: 300px;" class="mt-4">
      <canvas
        baseChart
        [datasets]="lineChartData1"
        [labels]="lineChartLabels1"
        [options]="lineChartOptions1"
        [colors]="lineChartColors1"
        [legend]="lineChartLegend1"
        [chartType]="lineChartType1"
      >
      </canvas>
    </div>
  </div>
</div>
